

















































































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'

export interface CollectionDetailTabLendItem {
  collectionLendBranchCode: SystemCode
  borrowingDate: string
  lendTotalCount: number
  lendCount3: number
  collectionLendUserId: string
  collectionLendPlaceCode: SystemCode
  borrowingDueDate: string // 日付
  lendCount0: number
  lendCount4: number
  collectionLendDate: string // 日付
  dueDate: string // 日付
  remindCount: number
  lendCount1: number
  lendCount5: number
  collectionLendType: SystemCode
  interlibraryLoanCode: SystemCode
  remindDate: string // 日付
  lendCount2: number
}

export const defaultCollectionDetailTabLendItem = (): CollectionDetailTabLendItem => ({
  collectionLendBranchCode: defaultSystemCode(),
  borrowingDate: '',
  lendTotalCount: 0,
  lendCount3: 0,
  collectionLendUserId: '',
  collectionLendPlaceCode: defaultSystemCode(),
  borrowingDueDate: '', // 日付
  lendCount0: 0,
  lendCount4: 0,
  collectionLendDate: '', // 日付
  dueDate: '', // 日付
  remindCount: 0,
  lendCount1: 0,
  lendCount5: 0,
  collectionLendType: defaultSystemCode(),
  interlibraryLoanCode: defaultSystemCode(),
  remindDate: '', // 日付
  lendCount2: 0
})

@Component({
  components: {}
})
export default class CollectionDetailTabLending extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: CollectionDetailTabLendItem

  @Prop({
    type: Boolean,
    default: false
  })
  isOrder!: boolean

  get lendTotalCount(): string {
    return this.displayNumberOnCollection(this.item.lendTotalCount)
  }

  get lendCount3(): string {
    return this.displayNumberOnCollection(this.item.lendCount3)
  }

  get lendCount0(): string {
    return this.displayNumberOnCollection(this.item.lendCount0)
  }

  get lendCount4(): string {
    return this.displayNumberOnCollection(this.item.lendCount4)
  }

  get remindCount(): string {
    return this.displayNumberOnCollection(this.item.remindCount)
  }

  get lendCount1(): string {
    return this.displayNumberOnCollection(this.item.lendCount1)
  }

  get lendCount5(): string {
    return this.displayNumberOnCollection(this.item.lendCount5)
  }

  get lendCount2(): string {
    return this.displayNumberOnCollection(this.item.lendCount2)
  }

  get isCollection(): boolean {
    return !this.isOrder
  }

  displayNumberOnCollection(num: number): string {
    return this.isCollection ? String(num) : ''
  }
}
